<div class="file-details">
  <div class="dark-blue">
    <nestas-toolbar [steps]="steps" [pid]="file.PID"></nestas-toolbar>
  </div>

  <div class="wrap">
    <nestas-pidinfo *ngIf="file.PID && steps" [steps]="steps" [pid]="file.PID"></nestas-pidinfo>

    <mat-card *ngIf="error" align="center">
      <div class="mat-card-wrapper">
        <div mat-card-image>
          <i class="material-icons red">error</i>
        </div>
        <mat-card-title>{{translate.instant(error)}}</mat-card-title>
      </div>

    </mat-card>

    <div class="display-flex">
      <div>
        <mat-card class="file-summary" *ngIf="file.PID">
          <!--<mat-card-title>
          {{translate.instant('CONTRACTOR_UPLOAD.FILE_SUMMARY')}}
        </mat-card-title>-->
          <div>
            <mat-card-actions class="actions">

              <div *ngIf="false">A {{userIsAllowed()}} FE {{ fileIsFullyEditable()}} C {{file.PID.copy}} R
                {{file.readOnly}} L {{file.locked}} VC {{currentVersion()}} CE {{canEdit()}} V {{file.version}}</div>
              <a *ngIf="userIsAllowed() && canEdit() && !file.PID.copy && !file.readOnly && !file.locked && currentVersion()"
                class="img border" (click)="modal.editFile = true;"
                [title]="translate.instant('BUTTON.ACTION.EDIT')"><img alt="duplicate" class="first"
                  src="../../assets/Nestas_toolbox_bewerken.png" /></a>

              <a *ngIf="file.version && file.version.date" class="img"
                [ngClass]="{'border' : !file.PID.copy && currentVersion() && !file.readOnly}"
                (click)="getOriginalFile()" [title]="translate.instant('PID.DOWNLOAD_ORIGINAL')"><img alt="download"
                  [ngClass]="{'first' : !canEdit() || !currentVersion() || !canEdit() || file.locked || file.PID.copy}"
                  src="../../assets/Nestas_toolbox_download.png" /></a>

              <a *ngIf="userIsAllowed() && canEdit() && !file.PID.copy && !file.readOnly && !file.locked && currentVersion() && rootPIDFile()"
                class="img border" (click)="lock()" [title]="translate.instant('BUTTON.ACTION.LOCK')"><img alt="lock"
                  src="../../assets/Nestas_toolbox_lock.png" /></a>

              <a *ngIf="userIsAllowed() && canEdit() && !file.PID.copy && !file.readOnly && file.locked  && currentVersion()"
                class="img border" (click)="unlock()" [title]="translate.instant('BUTTON.ACTION.UNLOCK')"><img
                  alt="unlock" src="../../assets/Nestas_toolbox_unlock.png" /></a>

              <a *ngIf="!file.PID.copy && !file.readOnly && currentVersion()" class="img"
                (click)="modal.linkFile = true; $event.stopPropagation();" [ngClass]="{'border' : userIsAllowed() && !file.PID.copy && !file.readOnly && !file.locked && currentVersion(),
                            'first': !canEdit() && !(file.version && file.version.date)}"
                [title]="translate.instant('BUTTON.ACTION.LINKTO')"><img alt="share"
                  src="../../assets/Nestas_toolbox_delen_narrow.png" /></a>

              <a *ngIf="userIsAllowed() && !file.PID.copy && !file.readOnly && !file.locked  && currentVersion()"
                class="img" (click)="deleteFile()" [title]="translate.instant('BUTTON.ACTION.DELETE')"><img alt="unlock"
                  src="../../assets/Nestas_toolbox_verwijderen.png" /></a>

            </mat-card-actions>

            <!--
          <div>
            <span class="highlight">{{translate.instant('DATA.NAME')}}:</span><br />{{file.name}}
          </div>
          <br />
          <div><span class="highlight">PID:</span><br />
            {{file.PID.name}}<br>
            {{file.PID.address.address}}<br *ngIf="file.PID.address.zip || file.PID.address.city" />
            {{file.PID.address.zip}} {{file.PID.address.city}}
          </div>
          <br />
          <div *ngIf="file.job"><span class="highlight">{{translate.instant('DATA.JOB')}}:</span><br />{{file.job}}
          </div>
          <br *ngIf="file.job" />
          <div *ngIf="file.type"><span class="highlight">{{translate.instant('DATA.TYPE')}}:</span><br /> {{file.type}}
          </div>
          <br *ngIf="file.type" />
          <div *ngIf="file.room"><span class="highlight">{{translate.instant('DATA.ROOM')}}:</span><br /> {{file.room}}
          </div>
          <br *ngIf="file.room" />
          <div *ngIf="file.description"><span class="highlight">{{translate.instant('DATA.DESCRIPTION')}}:</span><br />
            {{file.description}}</div>
          <br *ngIf="file.description" />
          -->
            
            <div style="margin-top: 40px">
              <span *ngIf="file.notifications" class="highlight">
                <span *ngIf="file.notifications.length">{{translate.instant('DATA.NOTIFICATIONS')}}:</span><span
                  *ngIf="!file.notifications.length">{{translate.instant('DATA.NO_NOTIFICATIONS')}}</span>
              </span><br />

              <div *ngFor="let n of file.notifications">
                {{translate.instant('DATA.' + n.frequency.toUpperCase())}}: {{n.topic}}
              </div>
            </div>
            <hr />

            <div>
              <span *ngIf="fileLinkStats" class="highlight">
                <span *ngIf="fileLinkStats.linked">
                  <!--{{fileLinkStats.linked}}x-->
                  {{translate.instant('LINKSTATS.SHARED')}}
                </span>
                <span *ngIf="!fileLinkStats.linked">{{translate.instant('LINKSTATS.NOT_SHARED')}}</span>
              </span>

              <div *ngFor="let ls of fileLinkStats.all">
                <span *ngIf="ls.deleted != true">{{ls.email}}

                  <!--<span *ngIf="ls.lastView">{{ls.count}}x
                  {{translate.instant('LINKSTATS.VIEWED')}}</span> <span
                  *ngIf="ls.lastView">{{translate.instant('LINKSTATS.LAST_ON')}}
                  {{ls.lastView | date: 'dd/MM/yyyy'}}</span>-->

                  <i class="material-icons cursor"
                    style="font-size: 14px; display: inline-flex; vertical-align: middle;" (click)="unlink(ls)"
                    [title]="translate.instant('BUTTON.ACTION.UNLINK')">cancel</i>
                </span>
              </div>

            </div>
            <hr />

            <div class="version">
              <span class="highlight">{{translate.instant('DATA.VERSIONS')}}:</span>

              <div *ngFor="let v of file.versions" class="versions">
                <a [ngClass]="{'active' : versionId == v._id}" style="width:185px; display:inline-block"
                  (click)="goToFileVersionDetails(v._id)">{{v.date | date: 'dd/MM/yyyy - H:mm:ss'}}</a>
                &nbsp;

                <i *ngIf="canDeleteVersion() " class="material-icons cursor"
                  style="font-size: 14px; display: inline-flex; vertical-align: middle;"
                  (click)="deleteFileVersion(file, v)" [title]="translate.instant('BUTTON.ACTION.UNLINK')">cancel</i>
              </div>

            </div>
            <hr />
            <div>
              <span class="highlight"><a class="step-name" (click)="goToAudittrail()">{{translate.instant('AUDITTRAIL.AUDITTRAIL2')}}</a></span>
            </div>



            <hr [ngStyle]="{'margin-bottom' : (isPhone) ? '75px' : '0'}" />

            <!--
          <div *ngIf="file.contractor.email"><span
              class="highlight">{{translate.instant('DATA.CONTRACTOR')}}:</span><br />
            {{file.contractor.name}}<br />
            <a href="mailto:{{file.contractor.email}}" class="link">{{file.contractor.email}}</a><br />
            {{file.contractor.phone}}
          </div>
          <br />-->
          </div>


          <!--
        <div *ngIf="!file.version || !file.version.date"><span
            class="highlight">{{translate.instant('DATA.DEADLINE')}}:</span><br />
          {{file.deadline | date: 'dd/MM/yyyy'}}<br /></div>

        <div *ngIf="file.version && file.version.date"><span
            class="highlight">{{translate.instant('DATA.COMPLETION_DATE')}}:</span><br />
          {{file.version.date | date: 'dd/MM/yyyy'}}<br /></div>
          -->

        </mat-card>
        <mat-card
          *ngIf="fileIsFullyEditable() && !file.readOnly && file.PID && !file.PID.copy && file.contractor && file.contractor.email"
          class="messageboxfd" style="margin:0;margin-top:10px" [style.width]="getMessageWidth()"
          [style.padding]="getMessagePadding()">
          <div (click)="openMessages = !openMessages" class="cursor">
            <div *ngIf="!openMessages" class="alert-info alert-info-reverse">
              <i [title]="translate.instant('DATA.CONTACT_CONTRACTOR')" class="material-icons ic-info">message</i>
              {{translate.instant('DATA.CONTACT_CONTRACTOR')}}
            </div>
            <div *ngIf="openMessages" class="close-box">
              <span>
                <i class="material-icons">close</i>
              </span>
            </div>
          </div>
          <div *ngIf="openMessages">
            <mat-card-subtitle>{{translate.instant('DATA.MESSAGES')}}</mat-card-subtitle>
            <message [messages]="messages" (send)="sendMessage($event)"></message>
          </div>
        </mat-card>
      </div>

      <mat-card class="card-drop full-width" style="margin-top:-40px"
        [ngStyle]="{'margin-bottom': (isPhone)? '0' : '350px'}">
        <!--<mat-card-title>
          <i class="material-icons" *ngIf="file.locked">lock</i>
          {{translate.instant('DATA.FILES')}}
        </mat-card-title>-->
        <mat-card-content>

          <!-- File table -->

          <ngx-datatable *ngIf="fileDetails" class="bootstrap" [rows]="fileDetails.slice(0,1)" [rowHeight]="getHeight()"
            [headerHeight]="getHeaderHeight()" [ngStyle]="{'margin-bottom' : (isPhone) ? '25px' : '0'}">

            <ngx-datatable-column name="Status" [width]="67" *ngIf="!isPhone" [sortable]="true"
              [comparator]="statusComparator" prop="locked">

              <ng-template let-row="row" ngx-datatable-cell-template>
                <div>
                  <img alt="{{row.status}}" class="logo" src="{{status2imgfn(row.status)}}"
                    style="height:64px;padding:12px;padding-left:4px;padding-right:10px" />
                </div>
              </ng-template>

            </ngx-datatable-column>

            <ngx-datatable-column name="{{translate.instant('DATA.NAME')}}" [width]="getWidth()" [sortable]="true"
              prop="name" [comparator]="comparator">

              <ng-template let-row="row" ngx-datatable-cell-template>
                <div class="divider left-divider" [ngStyle]="{'height': (isPhone) ? '92px' : '64px'}">
                  <div class="content" style="overflow:hidden" [ngStyle]="{'height': (isPhone) ? '76px' : '48px'}">

                    <div *ngIf="isPhone" class="compactheader">
                      <img alt="{{row.status}}" class="logo" src="{{status2imgfn(row.status)}}" style="height:16px;" />
                      <span>{{row.name}}</span>
                    </div>
                    <span *ngIf="!isPhone">{{file.name}}</span>
                    <div *ngIf="isPhone">
                      <div class="subcontent1L">{{row.metaType}}</div>
                      <div class="subcontent1L">{{row.description}}</div>
                      <div class="subcontent1L">{{formatContractor(row)}} {{row.deadline | date: 'dd/MM/yyyy'}}</div>
                    </div>

                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>


            <ngx-datatable-column name="{{translate.instant('DATA.TYPE')}}" *ngIf="!isPhone" [width]="200"
              [sortable]="true" prop="metaType" [comparator]="comparator">

              <ng-template let-row="row" ngx-datatable-cell-template>
                <div class="divider">
                  <div class="content">{{file.type}}</div>
                </div>
              </ng-template>
            </ngx-datatable-column>


            <ngx-datatable-column name="{{translate.instant('DATA.DESCRIPTION')}}" *ngIf="!isPhone" [width]="250"
              [sortable]="true" prop="description" [comparator]="comparator">

              <ng-template let-row="row" ngx-datatable-cell-template>
                <div class="divider">
                  <div style="height: 50px" class="content ellipsis">
                    {{file.description}}
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="{{translate.instant('DATA.ROOM')}}" *ngIf="!isPhone" class="tight" [width]="50"
              [sortable]="true" prop="room" [comparator]="comparator">

              <ng-template let-row="row" ngx-datatable-cell-template>
                <div class="divider">
                  <div class="content">
                    <img style="margin-left:0px; margin-top:10px" *ngIf="row.room" alt="{{row.room}}" class="logo"
                      src="{{room2imgfn(row.room)}}" style="height:25px;max-width:25px;" />
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="{{translate.instant('DATA.CONTRACTOR')}}" *ngIf="!isPhone" [width]="140"
              [sortable]="true" prop="contractor" [comparator]="comparator">

              <ng-template let-row="row" ngx-datatable-cell-template>
                <div class="divider">
                  <div class="content" [ngClass]="contractorClass(row)">
                    <div>{{formatContractor(row)}}</div>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="{{translate.instant('DATA.DEADLINE_TABLE')}}" *ngIf="!isPhone" [width]="100"
              [sortable]="true" prop="deadline" [comparator]="comparator">

              <ng-template let-row="row" ngx-datatable-cell-template>
                <div class="divider">
                  <div class="content center">
                    <div>{{row.deadline | date: 'dd/MM/yyyy'}}</div>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>

          </ngx-datatable>

         <!-- <div *ngIf="paginate && galleryImages && galleryImages.length">
            Selected index: {{selectedIndex}}
          </div>-->

          <ngx-gallery GalleryComponent *ngIf="galleryImages && galleryImages.length" style="margin-top:15px;"
            (change)="galleryChange($event)" (previewChange)="galleryPreviewChange($event)"
            (previewClose)="galleryPreviewClose($event)" [options]="galleryOptions" [images]="galleryImages"
            class="ngx-gallery"></ngx-gallery>

          <div *ngIf="paginate && galleryImages && galleryImages.length">
            <button class="pag" [disabled]="paginate.start == paginate.current"
              (click)="galleryPage(paginate.start)">{{paginate.start}}</button>
            <span *ngIf="showDotsPaginateMiddle(paginate)" class="dots">...</span>
            <button class="pag" [disabled]="page == paginate.current" (click)="galleryPage(page)"
              *ngFor="let page of paginate.middle">{{page}}</button>
            <span *ngIf="showDotsPaginateEnd(paginate)" class="dots">...</span>
            <button class="pag" [disabled]="page == paginate.current" (click)="galleryPage(page)"
              *ngFor="let page of paginate.end">{{page}}</button>
          </div>

          <!-- / File table -->
          <div class="alert-info" style="margin-top:20px" *ngIf="!rootPIDFile() && file.sharingType == 'shared'">
            <i class="material-icons ic-info">info</i>
            {{translate.instant('DATA.NO_EDIT_SHARED_1')}} &nbsp; <a class="link"
              (click)="editOnProject()">{{translate.instant('DATA.NO_EDIT_SHARED_2')}}</a>{{translate.instant('DATA.NO_EDIT_SHARED_3')}}.
          </div>

          <div style="margin-top:20px"
            *ngIf="((!fileViewUrls || !fileViewUrls.length) && (!galleryImages || !galleryImages.length)) && file.sharingType != 'distinct'" class="alert-info">
            <i class="material-icons ic-info">info</i>
            {{translate.instant('DATA.NO_FILE')}}
          </div>

          <div style="margin-top:40px" [hidden]="!fileViewUrls">
            <preview *ngIf="fileViewUrls && fileViewUrls.length" [files]="fileViewUrls"></preview>
          </div>

        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

<fsmodal [show]="modal.editFile" [closable]=true (closed)="modal.editFile = false;">
  <div class="modal-title-content">{{translate.instant('MODAL.TITLE.EDIT_FILE')}}</div>
  <div class="modal-body-content">
    <div>
      <nestas-toolbar [modal]="modal"></nestas-toolbar>
    </div>

    <div class="wrap" [ngStyle]="{'margin-top': (isPhone) ? '-100px' : '-60px'}">
      <nestas-pidinfo *ngIf="file.PID && steps" [steps]="steps" [pid]="file.PID"></nestas-pidinfo>

      <new-file #modalEditFile *ngIf="file && file.PID" [pid]="file.PID" [originPIDId]="originPIDId" [editFile]="file"
        (cancelled)="modal.editFile = false" (completed)="editCompleted($event);">
      </new-file>
      <div style="margin-top:40px; margin-bottom:120px;">
        <button mat-stroked-button (click)="modal.editFile = false;">{{translate.instant('BUTTON.ACTION.CANCEL')}}</button>
        <button mat-raised-button (click)="modalEditFile.addFile()" color="primary">
          {{translate.instant('BUTTON.ACTION.SAVE')}}
        </button>
      </div>
    </div>
  </div>
</fsmodal>

<modal [show]="modal.linkFile" [closable]=true (closed)="modal.linkFile = false;" class="link-file-component">
  <div class="modal-title-content">{{translate.instant('MODAL.TITLE.LINK_FILE')}}</div>
  <div class="modal-body-content">
    <mat-card-subtitle class="alert-info">
      <i class="material-icons ic-info">info</i>{{translate.instant('DATA.LINK_FILE')}}
    </mat-card-subtitle>
    <form class="full-width-form">
      <mat-form-field>
        <!--<input matInput [(ngModel)]="linkEmail" name="link_target_email" type="email"
          [placeholder]="translate.instant('DATA.EMAIL')" class="control-width">-->
        <input matInput type="text" name="linkEmail" [matAutocomplete]="contractorAutocomplete"
          placeholder="{{translate.instant('DATA.EMAIL')}}" class="full-width margin-right-md"
          [formControl]="contractorControl" [(ngModel)]="linkEmail">
        <mat-autocomplete #contractorAutocomplete="matAutocomplete">
          <mat-option *ngFor="let c of filteredContractors | async" [value]="formatLinkContractor(c)">
            {{formatLinkContractor(c)}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </form>
  </div>

  <div class="modal-footer-content">
    <button mat-stroked-button (click)="modal.linkFile = false;">{{translate.instant('BUTTON.ACTION.CANCEL')}}</button>
    
    <button mat-raised-button color="primary" (click)="initLinkFile(); ">
      {{translate.instant('BUTTON.ACTION.SEND')}}
    </button>
  </div>
</modal>


<modal [show]="modal.deleteFile" [closable]=true (closed)="modal.deleteFile = false;" class="default-pid-component">
  <div class="modal-title-content">{{translate.instant('BUTTON.ACTION.DELETE')}}</div>
  <div class="modal-body-content">
    <mat-card-title class="mat-card-title-attention">
      {{translate.instant('MESSAGE.CONFIRM_DELETE')}}
    </mat-card-title>
  </div>
  <div class="modal-footer-content">
    <button mat-stroked-button
      (click)="modal.deleteFile = false;modal.file = null;modal.version = null;">{{translate.instant('BUTTON.ACTION.CANCEL')}}</button>
     
    <button *ngIf="!modal.version" mat-raised-button color="primary" (click)="confirmDeleteFile()">
      {{translate.instant('BUTTON.ACTION.DELETE')}}
    </button>
    <button *ngIf="modal.version" mat-raised-button color="primary"
      (click)="confirmDeleteFileVersion(modal.file, modal.version)">
      {{translate.instant('BUTTON.ACTION.DELETE')}}
    </button>
  </div>
</modal>